import { CloseOutlined } from "@mui/icons-material";
import {
  Dialog,
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableBody,
  TableRow,
  Paper,
  IconButton,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { makeRequest } from "../apis/makeRequest";
import { getDescuento } from "../apis/backendRequests";
import { useSelector } from "react-redux";

const styles = {
  dialog: {
    "& .MuiBackdrop-root": {
      backgroundColor: "rgb(0,0,0,0.3)",
    },
  },
  unitario: {
    border: "0.2px solid #DEE0DD",
    borderRadius: "3px",
    fontWeight: "800",
    width: "20%",
    fontSize: "1rem",
  },
  subTotal: {
    backgroundColor: "#cccccc",
    borderRadius: "3px",
    fontWeight: "800",
    width: "20%",
    fontSize: "1rem",
  },
  descTotal: {
    border: "0.2px solid #DEE0DD",
    fontWeight: "800",
    width: "20%",
  },
};

const Disconts = ({ row, setter, isSubtotal, totalDesc, setTotal, finder }) => {
  const [descuentos, setDescuentos] = useState({});
  const { dynamicsId } = useSelector((state) => state.account);

  const handleClose = (e, reason) => {
    if (reason !== "backdropClick") setter({ ...row, show: false });
  };

  useEffect(() => {
    const id = isSubtotal ? row.productId : row.data.productId;
    if (!id) return;

    makeRequest(
      () =>
        getDescuento(
          id,
          dynamicsId,
          isSubtotal ? row.quantity : row.data.quantity
        ),
      (res) => {
        setDescuentos(res.data);
        res.data.productId = id

        if (isSubtotal) {
          setTotal((prev) => {
            const find = prev.find((i) => i.productId === res.data.productId);
            if (find) {
              return [...prev];
            }

            let item = {
              productId: id,
              desc: sumValues(res.data),
              detalle: res.data,
            };

            return [...prev, item];
          });
        }
      },

      null,
      { checkEmptyResults: false }
    );
  }, [row, isSubtotal]);

  function sumValues(obj) {
    let sum = 0;
    for (const key in obj) {
      if (typeof obj[key] === "number" && obj[key] > 0) {
        const boolKey = key + "bool";
        if (obj[boolKey] === true) {
          sum += obj[key];
        }
      }
    }
    return sum.toFixed(2);
  }


  return (
    <Dialog
      open={!isSubtotal && row.show}
      onClose={handleClose}
      maxWidth={"sm"}
      fullWidth
      sx={styles.dialog}
    >
      {Object.keys(descuentos).length !== 0 && !isSubtotal && (
        <TableContainer component={Paper} sx={{ paddingBottom: "5px" }}>
          <Table>
            <TableHead
              sx={{
                backgroundColor: "#CCCCCC",
              }}
            >
              <TableRow>
                <TableCell>
                  <IconButton onClick={handleClose}>
                    <CloseOutlined />
                  </IconButton>
                </TableCell>
                <TableCell colSpan={3}>Descuentos</TableCell>
                <TableCell align="right">Total</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {descuentos.bonifGralbool && descuentos.bonifGral > 0 && (
                <TableRow>
                  <TableCell />
                  <TableCell>Bonificacion</TableCell>
                  <TableCell
                    colSpan={3}
                    align="center"
                    sx={{ border: "0.2px solid #DEE0DD" }}
                  >
                    {descuentos.bonifGral.toFixed(2)}%
                  </TableCell>
                </TableRow>
              )}

              {descuentos.descLineabool && descuentos.descLinea > 0 && (
                <TableRow>
                  <TableCell />
                  <TableCell>Linea</TableCell>
                  <TableCell
                    colSpan={3}
                    align="center"
                    sx={{ border: "0.2px solid #DEE0DD" }}
                  >
                    {descuentos.descLinea.toFixed(2)}%
                  </TableCell>
                </TableRow>
              )}
              {descuentos.descBultobool && descuentos.descBulto > 0 && (
                <TableRow>
                  <TableCell />
                  <TableCell>Bulto</TableCell>
                  <TableCell
                    colSpan={3}
                    align="center"
                    sx={{ border: "0.2px solid #DEE0DD" }}
                  >
                    {descuentos.descBulto.toFixed(2)}%
                  </TableCell>
                </TableRow>
              )}

              {descuentos.descAdicionalbool && descuentos.descAdicional > 0 && (
                <TableRow>
                  <TableCell />
                  <TableCell>Adicional</TableCell>
                  <TableCell
                    colSpan={3}
                    align="center"
                    sx={{ border: "0.2px solid #DEE0DD" }}
                  >
                    {descuentos.descAdicional.toFixed(2)}%
                  </TableCell>
                </TableRow>
              )}
              <TableRow>
                <TableCell align="center" colSpan={3}>
                  Total Descuentos Aplicado
                </TableCell>
                <TableCell align="center" colSpan={3} sx={styles.descTotal}>
                  {sumValues(descuentos, row.data.productId)}%
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="right" colSpan={3}>
                  Monto Descuento
                </TableCell>
                <TableCell align="center" colSpan={3} sx={styles.unitario}>
                  {finder(totalDesc, row.data).descuento}$
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="right" colSpan={3}>
                  Su precio con descuento
                </TableCell>
                <TableCell align="center" colSpan={3} sx={styles.subTotal}>
                  {(finder(totalDesc, row.data).subtotal).toFixed(2)}$
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Dialog>
  );
};

export default Disconts;
